import NewCustomer from './NewCustomer'

export default NewCustomer



// WEBPACK FOOTER //
// ./src/components/Customers/New/index.js